// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

// Constants + helpers shared by the two Location admin pages
// (Settings → Standorte and Mandanten Management → Standorte) so the form
// stays consistent across both.

// Allowed timezones for the dropdown. Add more here when needed.
export const TIMEZONE_OPTIONS = [
  "Europe/Berlin",
  "Europe/London",
  "Europe/Paris",
];
export const DEFAULT_TIMEZONE = "Europe/Berlin";

// ISO 3166-1 alpha-3 options for the dropdown. The DB column is
// `country varchar(3)` so we store only the code; the label is for display.
export const COUNTRY_OPTIONS = [
  { code: "DEU", label: "Deutschland" },
  { code: "AUT", label: "Österreich" },
  { code: "CHE", label: "Schweiz" },
  { code: "FRA", label: "Frankreich" },
  { code: "ITA", label: "Italien" },
  { code: "NLD", label: "Niederlande" },
  { code: "BEL", label: "Belgien" },
  { code: "POL", label: "Polen" },
  { code: "GBR", label: "Vereinigtes Königreich" },
  { code: "USA", label: "Vereinigte Staaten" },
];
export const DEFAULT_COUNTRY = "DEU";

// URL-safe slug from the location name. Maps German umlauts to ASCII, lowers
// everything, collapses non-alphanumerics to single hyphens, trims edges, and
// caps at the column length (slug varchar(100) in vhp_location).
export const slugify = (str) => {
  if (!str) return "";
  return str
    .toLowerCase()
    .replace(/ä/g, "ae")
    .replace(/ö/g, "oe")
    .replace(/ü/g, "ue")
    .replace(/ß/g, "ss")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 100);
};
